// Loaded only for First Ollie and OG DENIM cards in the Gorras collection.
const ids = new Set(['15608280777030', '15608280482118', '15764033306950', '15763741016390', '15762858508614', '15773188686150', '15773682270534']);

function selectSwatch(event) {
  const swatch = event.target instanceof Element
    ? event.target.closest('.ms-card-swatch[data-ms-cap-variant]') : null;
  const card = swatch?.closest('product-card[data-ms-cap-card]');
  if (!card || !ids.has(card.dataset.productId)) return;
  if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (card.dataset.msCapVariant === swatch.dataset.msCapVariant) return;

  const slideshow = card.querySelector('[ref="cardGallery"] slideshow-component');
  if (!slideshow || typeof slideshow.select !== 'function') return;
  const slides = [...slideshow.querySelectorAll('slideshow-slide')];
  const matching = slides.filter(slide => slide.dataset.msCapPrefix === swatch.dataset.msCapPrefix);
  const first = matching.find(slide => slide.getAttribute('slide-id') === swatch.dataset.msCapMedia);
  if (!first) return;

  for (const slide of slides) {
    slide.hidden = !matching.includes(slide);
    slide.removeAttribute('reveal');
  }
  slideshow.select({ id: first.getAttribute('slide-id') }, undefined, { animate: false });
  card.dataset.msCapVariant = swatch.dataset.msCapVariant;
  for (const link of card.querySelectorAll('a[href]')) {
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname.startsWith('/products/')) {
      url.searchParams.set('variant', swatch.dataset.msCapVariant);
      link.href = url.href;
    }
  }
  const image = first.querySelector('img');
  if (image) card.dataset.featuredMediaUrl = image.currentSrc || image.src;
  for (const option of card.querySelectorAll('.ms-card-swatch[data-ms-cap-variant]')) {
    option.setAttribute('aria-pressed', String(option === swatch));
  }
  card.querySelector('quick-add-component')?.fetchProductPage?.(card.querySelector('[ref="productCardLink"]').href);
}

// Capture swatch activation before Horizon's card-navigation handler.
document.addEventListener('click', selectSwatch, true);
document.addEventListener('keydown', selectSwatch, true);
